export const getProcessedData = (data, currentLanguage, post) => {
  const languages = data.languages?.map((obj) => obj.code);
  const defaultLanguage = data?.defaultLanguage?.code;

  const menus = {};
  data.menus.nodes.forEach((node) => {
    menus[node.locations] = {
      ...node,
      menuItems: {
        nodes: node.menuItems.nodes.filter((node) => node.parentId === null),
      },
    };
  });

  const headerLinks =
    languages?.includes(currentLanguage) && currentLanguage !== defaultLanguage
      ? menus[`GATSBY_HEADER_MENU___${currentLanguage}`]?.menuItems.nodes
      : menus["GATSBY_HEADER_MENU"]?.menuItems.nodes;

  const headerFields =
    languages?.includes(currentLanguage) && currentLanguage !== defaultLanguage
      ? menus[`GATSBY_HEADER_MENU___${currentLanguage}`]?.headerFields
      : menus["GATSBY_HEADER_MENU"]?.headerFields;

  const footerLinks =
    languages?.includes(currentLanguage) && currentLanguage !== defaultLanguage
      ? menus[`GATSBY_FOOTER_MENU___${currentLanguage}`]?.menuItems.nodes
      : menus["GATSBY_FOOTER_MENU"]?.menuItems.nodes;

  const footerFields =
    data.footerSettings 
      ? data.footerSettings.footerFields
      : languages?.includes(currentLanguage) && currentLanguage !== defaultLanguage
        ? menus[`GATSBY_FOOTER_MENU___${currentLanguage}`]?.footerFields
        : menus["GATSBY_FOOTER_MENU"]?.footerFields;

  let translations;
  if (languages && languages.length > 1) {
    let paths;
    if (data.page) {
      paths = data.page?.translations?.reduce(
        (obj, translation) => (
          (obj[translation.language.code] = translation.uri), obj
        ),
        { [currentLanguage]: data.page.uri }
      );
    } else if (post) {
      paths = post.translation_uris;
    } else {
      paths = languages.reduce((obj, lang) => {
        obj[lang] = lang === "FI" ? "/" : `/${lang.toLowerCase()}`;
        return obj;
      }, {});
    }

    translations = {
      currentLanguage,
      order: languages && [...languages],
      paths: paths,
    };

    /*
    Example translation object:
    {
      "currentLanguage": 'FI'
      "order": [
          "FI",
          "SV",
          "EN"
      ],
      "paths": {
        "FI": "/tervetuloa",
        "SV": "/sv/valkommen",
        "EN": "/en/welcome",
      }
    }
  */
  }

  return {
    page: data.page,
    headerLinks,
    headerFields,
    footerLinks,
    footerFields,
    translations,
  };
};
